import tw from "twin.macro";

export const PrimaryLink = tw.a`cursor-pointer font-bold text-pbsGreen-500 border-b-2 border-transparent hocus:border-pbsGreen-500 hocus:text-pbsGreen-800 transition duration-300`;
